<template>
	<div class="forgot-password">
		<v-layout row wrap class='hidden-xs-and-down' v-if="!loading">
			<v-flex xs12 sm6 md6 class="div-container-description-forgot-password hidden-sm-and-down">
				<div class="layout-description-forgot">
					<p class="paragrafo-title-forgot-password">Ops!</p>
					<p class="paragrafo-description-forgot-password">
						Você esqueceu sua senha? Não tem problema! Insira seu <strong><i>e-mail</i></strong>
						cadastrado e nós enviaremos um código para recuperação.
					</p>
				</div>
			</v-flex>
			<v-flex xs12 sm8 md6 class="div-container-formulario-forgot-password" >
				<div class="layout-form-forgot">
					<div class="div-description-forgot-for-cellphone hidden-md-and-up">
						<p class="paragrafo-title-forgot-password">Ops!</p>
						<p class="paragrafo-description-forgot-password">
							Você esqueceu sua senha? Não tem problema! Insira seu <strong><i>e-mail</i></strong>
							cadastrado e nós enviaremos um código para recuperação.
						</p>
					</div>
					<v-form
						ref="form"
						v-model="valid"
						@submit.prevent="submit"
						lazy-validation
					>
							<v-text-field
								v-model="email"
								:rules="emailRules"
								label="E-mail"
								required
								outline
							></v-text-field>
							<div class="div-buttons-forgot-password">
								<button
									:disabled="!valid || email.length == 0"
									class="button-send-email"
									type="submit"
								>
									Enviar código de recuperação
								</button>
								<router-link class="button-back-login" to="/login">
									Voltar à página de acesso
								</router-link>
							</div>
					</v-form>
				</div>
			</v-flex>
		</v-layout>
		<v-layout row wrap v-else >
			<v-flex xs12 sm12 md12 class="div-loading-circle-forgot-password">
					<v-progress-circular
						indeterminate
						color="primary"
					></v-progress-circular>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import { affiliate_api } from '@/api'

export default {
	name: 'ForgotPassword',
	mixins: [affiliate_api],
	data() {
		return {
			valid: false,
			loading: false,
			email: '',
			emailRules: [
				(v) => !!v || 'E-mail é obrigatório',
				(v) => /.+@.+/.test(v) || 'E-mail deve ser válido',
			],
		}
	},
	methods: {
		submit: async function () {
			try {

				this.loading = true

				await this.get_forgot_password(this.email)

				this.$notify({
					type: 'success',
					title: 'Verifique seu email, um código foi enviado com sucesso!',
				})

				this.$router.push('/forgot_login/reset_password')

			} catch (err) {

				this.$notify({
					type: 'error',
					title: 'Este e-mail não está cadastrado na plataforma!',
				})

			}

			this.loading = false

		}
	}
}

</script>


<style>

.forgot-password {
	height: 90vh;
	display: flex;
	align-items: center;
	justify-content: center;
}

.div-container-description-forgot-password .layout-description-forgot {
	width: 60%;
	padding-left: 20px;
}

.div-container-description-forgot-password .layout-description-forgot .paragrafo-title-forgot-password {
	font-size: 48px;
	line-height: 60px;
	font-weight: 900;
	color: #FFFFFF !important;
}

.div-container-description-forgot-password .layout-description-forgot p.paragrafo-description-forgot-password {
	font-size: 15px;
	line-height: 22px;
	font-weight: 300;
}

.div-container-description-forgot-password .layout-description-forgot p.paragrafo-description-forgot-password strong {
	font-weight: 900;
}

.div-description-forgot-for-cellphone p.paragrafo-title-forgot-password {
	font-size: 28px;
	line-height: 60px;
	font-weight: 900;
	color: #FFFFFF !important;
	text-align: center;
	margin-bottom: 5px;
}

.div-description-forgot-for-cellphone p.paragrafo-description-forgot-password {
	font-size: 15px;
	line-height: 22px;
	font-weight: 300;
	text-align: center;
	margin-bottom: 30px;
}

.div-description-forgot-for-cellphone p.paragrafo-description-forgot-password strong {
	font-weight: 900;
}

.div-container-formulario-forgot-password {
	background: #2D2F32;
	box-shadow: 9px 9px 16px rgba(0, 0, 0, 0.25), -9px -9px 16px rgba(74, 74, 74, 0.25);
	border-radius: 23px;
	padding: 30px 12px 20px 12px;
}

.div-container-formulario-forgot-password .layout-form-forgot {
	width: 80%;
	margin: auto;
}

/* Begin input */

div.layout-form-forgot .v-text-field__slot {
	margin: 0px;
}

.div-container-formulario-forgot-password .v-label.v-label--active.theme--light.primary--text {
	color: #40DA99 !important;
}

/* End input */

.div-container-formulario-forgot-password .div-buttons-forgot-password {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.div-container-formulario-forgot-password .div-buttons-forgot-password button.button-send-email {
	background: #40DA99;
	box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.25), -3px -3px 8px rgba(74, 74, 74, 0.25);
	border-radius: 23px;
	padding: 4px 20px;
	color: #2D2F32 !important;
	font-weight: 600;
	margin: 15px 0px 12px 0px;
}

.div-container-formulario-forgot-password .div-buttons-forgot-password button.button-send-email:hover {
	background: #fff;
	color: #2D2F32 !important;
}

.div-container-formulario-forgot-password .div-buttons-forgot-password button.button-send-email:disabled {
  opacity: 0.4;
	background: #40DA99;
	color: #2D2F32 !important;
	cursor: not-allowed;
}

.div-container-formulario-forgot-password .div-buttons-forgot-password .button-back-login {
	background: #2D2F32;
	box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.25), -3px -3px 8px rgba(74, 74, 74, 0.25);
	border-radius: 23px;
	text-align: center;
	text-decoration: none;
	margin-top: 5px;
	color: #40DA99 !important;
	padding: 4px 20px;
	font-weight: 500;
}

.div-container-formulario-forgot-password .div-buttons-forgot-password .button-back-login:hover {
	background: #fff;
	color: #2D2F32 !important;
}

/* Begin loading circle */

.div-loading-circle-forgot-password {
	display: flex;
	align-items: center;
	justify-content: center;
}

.div-loading-circle-forgot-password circle.v-progress-circular__overlay{
	color: #40DA99 !important;
}

/* End loading circle */

@media (max-width: 960px) {
	.div-container-formulario-forgot-password {
		margin: auto;
	}
}

@media (max-width: 600px) {
	.div-container-formulario-forgot-password {
		margin: 0px 20px;
	}
}

</style>
